import t from '@instructure/quiz-i18n/format-message';
export var length = function length(val, options) {
  var strVal = val || '';
  var minMessage = options.minMessage || t('too few characters');
  var maxMessage = options.maxMessage || t('too many characters');
  if (options.min && strVal.length < options.min) {
    return minMessage;
  }
  if (options.max && strVal.length > options.max) {
    return maxMessage;
  }
};
export default length;